import React from "react";
import { Skeleton } from "@mui/material";
export const RedesSkeleton = () => {
	return (
		<div className="redes-company">
			<div className="title-redes">
				<div className="title-redes-one">
					<Skeleton variant="text" width={200} height={30} />
				</div>
				<div className="title-redes-two">
					<Skeleton variant="text" width={180} height={40} />
				</div>
			</div>

			<div className="redes-one">
				<div className="social-links">
					{[0, 1].map((index) => (
						<div className="section-social" key={index}>
							<Skeleton variant="circular" width={75} height={75} />
						</div>
					))}
				</div>
			</div>

			<div className="redes-two">
				<div className="social-links">
					{[0, 1].map((index) => (
						<div className="section-social" key={index}>
							<Skeleton variant="circular" width={75} height={75} />
						</div>
					))}
				</div>
			</div>

			<div className="redes-photo">
				<div className="section-social-globitos">
					<Skeleton variant="rectangular" width="100%" height={150} />
					<div className="section-social-photo">
						<Skeleton variant="rectangular" width={120} height={200} />
					</div>
				</div>
			</div>
		</div>
	);
};
